<template>
    <v-dialog
        v-if="contact"
        v-model = "value"
        persistent
        max-width="900"
    >
        <v-card>
            <v-card-title class="headline primary white--text" >
                Kontakte zusammenfassen
            </v-card-title>
            <v-card-text class="pa-3">
                <v-progress-linear
                    v-if="loading"
                    indeterminate
                    color  = "primary"
                    height = "10"
                    class  = "w-100 mb-2"
                />

                <div class="v-flex">
                    <div class="lm-border pa-3" style="width: calc(50% - 25px);">
                        <div class="mt-14" >
                            <customer-contact-card
                                :contact="contact"
                                :edit="false"
                            />
                        </div>

                    </div>
                    <div>
                        <v-icon class="primary--text" style="margin-top: 145px; width: 50px" size="40">mdi-arrow-right-bold</v-icon>
                    </div>
                    <div class="lm-border pa-3" style="width: calc(50% - 25px);">
                        <v-row class="no-frame mb-2">
                            <div class="v-flex w-100">
                                <v-text-field
                                    v-model        = "searchtext"
                                    autocomplete   = "off"
                                    autocorrect    = "off"
                                    autocapitalize = "off"
                                    spellcheck     = "false"
                                    append-icon    = "fas fa-search"
                                    class          = "pb-1"
                                    clearable
                                    hide-details
                                />
                            </div>
                        </v-row>
                        <v-data-iterator
                            v-if            = "contacts"
                            :items          = "contacts"
                            :page.sync      = "page"
                            :search         = "searchtext"
                            :custom-filter  = "cfilter"
                            :items-per-page = "1"
                            class           = "data-iterator"
                            hide-default-footer
                        >
                            <template v-slot:default="props">
                                <customer-contact-card
                                    v-for="(item, index) in props.items"
                                    :contact="item"
                                    :edit="false"
                                    :key="index"
                                />
                            </template>
                            <template v-slot:footer="{ pagination }">
                                <div
                                    v-show = "pagination.pageCount > 1"
                                    class  = "max-width pt-2"
                                >
                                    <v-pagination
                                        v-model        = "page"
                                        :length        = "pagination.pageCount"
                                        :total-visible = "5"
                                    ></v-pagination>
                                </div>
                            </template>
                        </v-data-iterator>
                    </div>
                </div>
            </v-card-text>
            <v-card-actions class="pb-4">
                <v-spacer></v-spacer>
                <v-btn
                    v-if="saved"
                    class  = "dialog-button mr-2"
                    @click = "onCancel"
                    depressed
                >
                    Schliessen
                </v-btn>
                <v-btn
                    v-if="!saved"
                    class  = "dialog-button mr-2"
                    @click = "onCancel"
                    depressed
                >
                    Abbrechen
                </v-btn>
                <v-btn
                    v-if="!saved"
                    class  = "dialog-button primary pl-3 pr-3"
                    @click = "onSave"
                    depressed
                >
                    OK
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import CustomerContactCard from "@/modules/msd/company/contact/components/controlls/CContactCard";
import Contact from "@/modules/msd/company/contact/service/Contact";
import Core from "@/modules/core/service/Core";
export default {
    name: "DContactCombine",
    components: {
        CustomerContactCard
    },

    props: {
        value: {

        },

        contacts: {
            required: false,
            type    : Array,
            default: function () {
                return null;
            }
        },

        contact: {
            required: false,
            type    : Object,
            default: function () {
                return null;
            }
        }
    },

    watch: {
        selected: {
            deep: true,
            handler: function () {
            }
        }
    },

    data: () => ({
        page      : 1,
        saved     : false,
        loading   : false,
        selected  : null,
        searchtext: "",
    }),

    computed: {
    },

    methods: {
        onSave () {
            Core.message.confirm(
                this,
                this.$t('contact.combine.confirm.query'),
                this.$t('contact.combine.confirm.text'),
                Core.message.Default,
                (value) => {
                    if (value) {
                        this.loading = true;
                        const current = this.cfilter(this.contacts, this.searchtext);
                        const target = current[this.page-1];
                        Contact.move(this.contact.id, target.id).then (() => {
                            this.$emit("combined");
                            this.loading = false;
                            this.saved = true;
                        })
                    }
                });
        },

        onCancel () {
            this.$emit("input", false);
            this.saved = false;
        },

        cfilter (items, search) {
            if (!search) {
                return this.contacts;
            }

            return this.contacts.filter (contact => {
                if (contact.name.includes(this.searchtext)) {
                    return true;
                }

                return !!(contact.company && contact.company.name && contact.company.name.includes(this.searchtext));
            });
        },
    }
}
</script>

<style scoped>

.headline {
    font-size: 16px!important;
    height: 35px;
    padding-top: 3px!important;
}

</style>